import { crudMdActions } from "@/services/crud-md-actions";

const name = "centers";

export default {
  name,
  ...crudMdActions(name),
};
